import React from 'react';
import { Button } from '@mui/material';
import { FacebookAuthProvider, signInWithPopup } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../firebase';  // Import your Firebase auth instance
import { useUser } from 'utils/UserContext';

const FacebookLoginButton = () => {
  const navigate = useNavigate();
  const { fetchUserData } = useUser();

  const handleFacebookLogin = async () => {
    const provider = new FacebookAuthProvider();

    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      // Optionally, you can save additional user data to your MySQL database here
      await fetchUserData();
      navigate('/dashboard');
    } catch (error) {
      console.error('Facebook login error:', error);
      // Handle errors here, e.g., show a notification
    }
  };

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={handleFacebookLogin}
    >
      Continue with Facebook
    </Button>
  );
};

export default FacebookLoginButton;
